// src/pages/logistica/ForecastVsReal.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

export default function ForecastVsReal() {
  const [semanas, setSemanas] = useState([]);
  const [semanaSeleccionada, setSemanaSeleccionada] = useState('');
  const [filas, setFilas] = useState([]);
  const [semanaMostrada, setSemanaMostrada] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    api.get('/api/logistica/forecast/semanas-disponibles').then((res) => setSemanas(res.data.data)).catch(console.error);
  }, []);

  async function cargar(semana) {
    try {
      setCargando(true);
      const res = await api.get('/api/logistica/forecast/comparativo', semana ? { params: { semana } } : {});
      setFilas(res.data.data);
      setSemanaMostrada(res.data.semana);
      setSemanaSeleccionada(res.data.semana || '');
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []); // eslint-disable-line

  if (cargando) return <div style={styles.contenedor}>Cargando...</div>;

  return (
    <div style={styles.contenedor}>
      <h1 style={styles.titulo}>Forecast vs Real</h1>
      <p style={styles.subtitulo}>Comparación entre lo planeado (Fcst) y lo realmente facturado, por artículo y semana.</p>

      <div style={styles.controles}>
        <label style={styles.label}>
          Semana
          <select value={semanaSeleccionada} onChange={(e) => { setSemanaSeleccionada(e.target.value); cargar(e.target.value); }} style={styles.input}>
            {semanas.map((s) => (
              <option key={s} value={s}>{new Date(s).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}</option>
            ))}
          </select>
        </label>
      </div>

      {filas.length === 0 && (
        <div style={styles.tarjeta}>
          <p style={{ color: '#8A7690', fontSize: '12px' }}>
            Sin datos todavía. Sube un archivo en <strong>Importar Forecast</strong> y asegúrate de mapear los nombres en <strong>Mapeo de Forecast</strong>.
          </p>
        </div>
      )}

      {filas.length > 0 && (
        <div style={styles.tarjeta}>
          <div style={styles.seccionTitulo}>
            Semana del {semanaMostrada && new Date(semanaMostrada).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}
          </div>
          <table style={styles.tabla}>
            <thead>
              <tr>
                <th style={styles.th}>Artículo</th>
                <th style={styles.thNum}>Pronosticado</th>
                <th style={styles.thNum}>Real</th>
                <th style={styles.thNum}>Variación</th>
              </tr>
            </thead>
            <tbody>
              {filas.map((f) => (
                <tr key={f.articulo}>
                  <td style={styles.td}>{f.articulo}</td>
                  <td style={styles.tdNum}>{Number(f.pronosticado).toLocaleString('es-MX')}</td>
                  <td style={styles.tdNum}>{Number(f.real).toLocaleString('es-MX')}</td>
                  <td style={{ ...styles.tdNum, fontWeight: 700, color: f.variacion_pct === null ? '#8A7690' : Math.abs(f.variacion_pct) <= 15 ? '#3E7C5A' : Math.abs(f.variacion_pct) <= 30 ? '#B8862E' : '#B23A48' }}>
                    {f.variacion_pct === null ? '—' : `${f.variacion_pct > 0 ? '+' : ''}${f.variacion_pct}%`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '780px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '2px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '16px' },
  controles: { marginBottom: '16px' },
  label: { display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '11px', color: '#8A7690', fontWeight: 600, textTransform: 'uppercase' },
  input: { padding: '8px 10px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7', minWidth: '220px' },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  seccionTitulo: { fontSize: '13px', fontWeight: 700, color: '#2A1830', marginBottom: '12px' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '12.5px' },
  th: { textAlign: 'left', padding: '8px 10px', color: '#8A7690', fontSize: '11px', textTransform: 'uppercase', borderBottom: '2px solid #E6DDD2' },
  thNum: { textAlign: 'right', padding: '8px 10px', color: '#8A7690', fontSize: '11px', textTransform: 'uppercase', borderBottom: '2px solid #E6DDD2' },
  td: { padding: '7px 10px', borderBottom: '1px solid #F0E9E0' },
  tdNum: { padding: '7px 10px', textAlign: 'right', borderBottom: '1px solid #F0E9E0' },
};
